import { ConfigData } from './../../../app.config';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavLink } from '../../../models/nav-link';
import { ConfigurationService } from 'app/_services/configuration.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { ConfirmationDialogService } from 'app/_services/confirmation-dialog.service';
import { LanguageService } from 'app/_services/language.service';
import { AuthenticationService } from 'app/_services/authentication.service';
import { PERMISSION_CODES } from 'app/constants/permission-codes';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'fury-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})
export class ConfigurationComponent implements OnInit, OnDestroy {
  navLinks: NavLink[];

  selectedRoute: string;

  loading = false;

  private destroy$ = new Subject();

  constructor(
    private configurationService: ConfigurationService,
    private confirmationDialogService: ConfirmationDialogService,
    public languageService: LanguageService,
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  ngOnInit() {
    this.buildTabs();

    this.languageService.languageChanged$
      .pipe(takeUntil(this.destroy$))
      .subscribe((_) => this.buildTabs());
  }

  private buildTabs(): void {
    this.navLinks = [];
    this.selectedRoute = this.router.url.split('/')[2] || null;

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CONFIGURAZIONE_TABS.PROPRIETA_SISTEMA)) {
      this.navLinks.push({
        path: 'sysprops',
        label: this.languageService.getLabel('configuration.ProprietaDiSistema'),
        disabled: false,
        visible: true
      });

      this.selectedRoute = this.selectedRoute || 'sysprops';
    }

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CONFIGURAZIONE_TABS.TEMPLATE_SEARCH)) {
      this.navLinks.push({
        path: 'tempsearch',
        label: this.languageService.getLabel('configuration.TemplateSearch'),
        disabled: false,
        visible: true
      });

      this.selectedRoute = this.selectedRoute || 'tempsearch';
    }

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CONFIGURAZIONE_TABS.LINGUA)) {
      this.navLinks.push({
        path: 'language',
        label: this.languageService.getLabel('configuration.Language'),
        disabled: false,
        visible: true
      });

      this.selectedRoute = this.selectedRoute || 'language';
    }

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CONFIGURAZIONE_TABS.INCLUDE_FREEMARKER)) {
      this.navLinks.push({
        path: 'inclfree',
        label: this.languageService.getLabel('configuration.IncludeFreemarker'),
        disabled: false,
        visible: true
      });

      this.selectedRoute = this.selectedRoute || 'inclfree';
    }

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CONFIGURAZIONE_TABS.INCLUDE_XLST)) {
      this.navLinks.push({
        path: 'inclxlst',
        label: this.languageService.getLabel('configuration.IncludeXslt'),
        disabled: false,
        visible: true
      });

      this.selectedRoute = this.selectedRoute || 'inclxlst';
    }


    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CONFIGURAZIONE_TABS.SPEECH_TO_TEXT)) {
      this.navLinks.push({
        path: 'speech-to-text',
        label: this.languageService.getLabel('configuration.SpeechToText'),
        disabled: false,
        visible: true
      });

      this.selectedRoute = this.selectedRoute || 'speech-to-text';
    }

    if (this.authenticationService.userHasPermission(PERMISSION_CODES.CONFIGURAZIONE_TABS.SYSTEM_EMAIL)) {
      this.navLinks.push({
        path: 'system-email',
        label: this.languageService.getLabel('configuration.SystemEmail'),
        disabled: false,
        visible: true
      });

      this.selectedRoute = this.selectedRoute || 'system-email';
    }

    if (this.selectedRoute) {
      this.router.navigate(['configuration/' + this.selectedRoute]);
    }
  }

  flushCache(): void {
    this.loading = true;
    this.configurationService
      .flushCache()
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(() => {
        this.loading = false;
        this.confirmationDialogService
          .confirm(
            this.languageService.getLabel('configuration.MessaggioModaleCache'),
            this.languageService.getLabel('configuration.TitoloModaleCache'),
            this.languageService.getLabel('general.OK'),
            ''
          )
          .then(() => { });
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
